module.exports = __webpack_public_path__ + "static/media/feature_stack.c293caac.png";